export default __webpack_public_path__ + "static/media/illustration-editor-desktop.c6c8050a.svg";